// extracted by mini-css-extract-plugin
export default {"dlDecimalFormatter":"src-js-common-components-formatters-DecimalFormatter---dlDecimalFormatter---0+5WE"};